import { EventType } from './events';

export interface Event {
  id: number;
  remoteObjectId: string;
  name: string;
  nameFr?: string;
  type: string;
  isActive: boolean;
  isMaroline: boolean;
  description: string | null;
  descriptionFr?: string | null;
  startDate: string;
  endDate: string;
  location: string | object;
  status: string;
  ultimateParent: string;
  pointsToEarn: number | null;
  duration: number | null;
  eventType: string | null;
  eventSubtype: string | null;
  showroom?: string;
  appointmentId?: string;
  city?: string;
  durationUnit?: string;
  isAttended?: boolean;
  isBooked?: boolean;
}

// Helper function to normalize event types from API to our EventType
export const normalizeEventType = (type: string | null | undefined): EventType => {
  if (!type) return 'In-Person';
  
  // Convert Online to Virtual
  if (type.toLowerCase() === 'online') return 'Virtual';
  
  // If it's already one of our types, use it
  if (type === 'In-Person' || type === 'Virtual') return type;
  
  // Default fallback
  return 'In-Person';
};

// Helper function to get translation key for event type
export const getEventTypeTranslationKey = (type: EventType): string => {
  return `eventType.${type === 'In-Person' ? 'inPerson' : 'virtual'}`;
};
